import { inject, Injectable } from "@angular/core";
import { PeoState, PeoStoreService } from "./peo-store.service";
import { EntityFacadeService } from "../../../../shared/store/entity-store/entity-facade.service";
import { EntityMetadata } from "../../../../shared/store/store-types.model";
import { PeoApiService } from "./peo-api.service";
import { ProcessEtapeOpe } from "../../models/peo.model";
import {
  Untrack,
  UpdateStatus,
} from "../../../../shared/store/utils/store-utils.service";
import { ChecklistFacadeService } from "../../../list/services/store/checklist-facade.service";
import { firstValueFrom } from "rxjs";
import { ControleFacadeService } from "../../../controle/services/store/controle-facade.service";

@Injectable({ providedIn: "root" })
export class PeoFacadeService extends EntityFacadeService<
  ProcessEtapeOpe,
  PeoApiService,
  PeoState,
  EntityMetadata,
  PeoStoreService
> {
  checklistFacadeService = inject(ChecklistFacadeService);
  controlesFacadeService = inject(ControleFacadeService);

  constructor() {
    const api = inject(PeoApiService);
    const store = inject(PeoStoreService);
    super(api, store);
    this.store.initStatus(PeoFacadeService);
  }

  @Untrack
  @UpdateStatus
  async startPeo(id: string) {
    const peo = await this.api.startPeo(id);
    this.store.upsertOne(peo);
    return peo;
  }

  @Untrack
  @UpdateStatus
  async endPeo(id: string) {
    const peo = await this.api.endPeo(id);
    this.store.upsertOne(peo);
    return peo;
  }

  @Untrack
  @UpdateStatus
  async endPeoForChecklist(id: string, checklistId: string) {
    const res = await this.api.endPeoForChecklist(id, checklistId);
    this.store.upsertOne(res.peo);
    this.checklistFacadeService.store.upsertOne(res.checklist);
    return res.peo;
  }

  @Untrack
  @UpdateStatus
  async resetEndPeo(id: string) {
    const peo = await this.api.resetEndPeo(id);
    this.store.upsertOne(peo);
    return peo;
  }

  @Untrack
  @UpdateStatus
  async loadAllForChecklistAndSetPods(checklistId: string) {
    const peos = await firstValueFrom(
      this.api.loadAllEagerForChecklist(checklistId),
    );
    for (let peo of peos) {
      this.store.upsertOne(peo);
      if (peo.pod?.controles?.length) {
        for (let c of peo.pod.controles) {
          this.controlesFacadeService.store.upsertOne(c);
        }
      }
    }
  }
}
